import { render, staticRenderFns } from "./ViqFollowUps.vue?vue&type=template&id=f7045816&scoped=true"
import script from "./ViqFollowUps.vue?vue&type=script&lang=js"
export * from "./ViqFollowUps.vue?vue&type=script&lang=js"
import style0 from "./ViqFollowUps.vue?vue&type=style&index=0&id=f7045816&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7045816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7045816')) {
      api.createRecord('f7045816', component.options)
    } else {
      api.reload('f7045816', component.options)
    }
    module.hot.accept("./ViqFollowUps.vue?vue&type=template&id=f7045816&scoped=true", function () {
      api.rerender('f7045816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqFollowUps.vue"
export default component.exports